import { AttachingMethod, Attachment } from '../../../../types';
import { experiments } from '../../../experiments';
import { logger } from '../../../util/logger';
import { renderModel } from '../../../util/renderModel';
import { httpClient } from '../../httpClient';
import { getMediaAuthToken } from '../getMediaToken';
import { getMediaType } from './getMediaType';
import { getUploadUrl } from './getUploadUrl';
import { mapUploadResponse } from './mapUploadResponse';
import { UploadFileResponse } from './types';
import { DynamicsMediaUploader } from './uploadDynamicsMedia';

const createBody = (file: File, uploadToken: string): FormData => {
  const formData = new FormData();
  const mediaType = getMediaType(file);

  formData.set('upload_token', uploadToken);
  formData.set('media_type', mediaType);
  formData.set('parent_folder_id', 'visitor-uploads');
  formData.set('file', file, file.name);

  return formData;
};

export const uploadMedia = async (
  files: File[],
  attachingMethod: AttachingMethod,
  signal: AbortSignal,
): Promise<Attachment[]> => {
  return experiments.is('specs.chatbot.DynamicsMigration', 'true')
    ? DynamicsMediaUploader.upload(files, attachingMethod, signal)
    : uploadMediaLegacy(files, attachingMethod, signal);
};

export const uploadMediaLegacy = async (
  files: File[],
  attachingMethod: AttachingMethod,
  signal: AbortSignal,
): Promise<Attachment[]> => {
  const mediaAuthToken = await getMediaAuthToken();

  try {
    return Promise.all(
      files.map(async (file) => {
        const { upload_url, upload_token } = await getUploadUrl(file, mediaAuthToken);
        const body = createBody(file, upload_token);
        const source = httpClient.getInstance().CancelToken.source();
        signal.onabort = () => source.cancel();

        const {
          data: [uploadedFile],
        } = await httpClient
          .getInstance()
          .post<UploadFileResponse[]>(upload_url, body, { cancelToken: source.token });

        return mapUploadResponse(uploadedFile, attachingMethod);
      }),
    );
  } catch (error) {
    logger.error({
      message: 'fail to upload media',
      error,
      callParams: renderModel.get(),
    });
    throw error;
  }
};
